import * as Common from 'components/common/Common'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Select, { SingleValue } from 'react-select'
import Flag from 'react-world-flags'
import { useTheme } from 'styled-components'

type LanguageOption = {
  value: string
  label: React.ReactNode
}

const LanguagePicker = () => {
  const { i18n } = useTranslation()
  const lang = i18n.language || 'en'
  const theme = useTheme()

  const languages: LanguageOption[] = [
    {
      value: 'en',
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Flag
            code="gb"
            style={{ width: 20, marginRight: 8 }}
          />
          EN
        </div>
      ),
    },
    {
      value: 'pl',
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Flag
            code="pl"
            style={{ width: 20, marginRight: 8 }}
          />
          PL
        </div>
      ),
    },
    {
      value: 'es',
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Flag
            code="es"
            style={{ width: 20, marginRight: 8 }}
          />
          ES
        </div>
      ),
    },
  ]

  const handleChange = (option: SingleValue<LanguageOption>) => {
    if (option) void i18n.changeLanguage(option.value)
  }

  return (
    <Common.Div
      flex="row"
      alignItems="center"
    >
      <Select
        options={languages}
        value={languages.find(l => l.value === lang)}
        onChange={handleChange}
        styles={{
          control: base => ({
            ...base,
            backgroundColor: theme.colors.bar,
            border: 'none',
            boxShadow: 'none',
            caretColor: 'transparent',
            color: theme.colors.secondary,
          }),
          singleValue: base => ({
            ...base,
            color: theme.colors.secondary,
          }),
          menu: base => ({
            ...base,
            backgroundColor: theme.colors.bar,
            color: theme.colors.secondary,
          }),
          dropdownIndicator: (base, state) => ({
            ...base,
            color: theme.colors.secondary,
            transform: state.selectProps.menuIsOpen
              ? 'rotate(180deg)'
              : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
            ':hover': {
              color: theme.colors.secondary,
            },
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
              ? theme.colors.primary
              : state.isFocused
                ? theme.colors.primary
                : theme.colors.bar,
            color: theme.colors.secondary,
            ':active': {
              backgroundColor: theme.colors.primary,
            },
          }),
        }}
        aria-label="Select language"
      />
    </Common.Div>
  )
}

export default LanguagePicker
